import { Accordion, Spinner, Alert } from '@gsa/afp-component-library';
import './select-options.scss';
import {
  useGetAddOptions,
  useGetMinOptions,
} from '../../../../../requests/additionals-request';
import { useNavigate } from 'react-router-dom';
import MinimumRequirementGroup from '../../../../vehicle-referral/replace-vehicle/steps/select-options/minimum-requirement-group';
import AdditionalOptionsGroup from './additional-options-group';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ADDITIONAL_VEHICLE_STEPS } from '../../create-vehicle-request-steps.jsx';
import { useSelector } from 'react-redux';
import { changeAdditionalsStep } from '../../../../../reducers/additionals-reducer';
import { emDashUnicode } from '@gsa/afp-shared-form-utils';
import AdditionalRequestActionButtons from '../../../components/additionals-request-buttons/additionals-request-buttons';
import useCreateAdditionalDraft from '../../../components/create-draft/use-create-additional-draft.js';
import useBackToList from '../../../utils/use-back-to-list'

export default function AdditionalsSelectOptions() {
  const { selectedStandardItem, selectedOptions, previousOptions, status } =
    useSelector((state) => state.additionalsReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { requestId } = useParams();
  const { backToList } = useBackToList();
  const [updateAdditionalsDraft] = useCreateAdditionalDraft();
  const loading = [];

  // get the minimum options for the given standard item
  const minimumOptions = useGetMinOptions(selectedStandardItem?.id);
  loading.push(minimumOptions.loading);

  // get the additional options for the given standard item
  const additionalOptions = useGetAddOptions(selectedStandardItem?.id);
  loading.push(additionalOptions.loading);

  const isLoading = loading.some((l) => l);

  const handleSubmit =
    (autoNavigate = false, navigateStep) =>
    () => {
      const payload = {
        additionalRequestId: requestId,
        options: selectedOptions
          .map((option) =>
            option?.option?.equipmentCode?.code
              ? {
                  equipmentCode: option.option.equipmentCode.code,
                  comment: option.comment,
                }
              : null,
          )
          .filter((option) => option !== null),
      };
      updateAdditionalsDraft(payload).then(({ data }) => {
        if (data) {
          dispatch(changeAdditionalsStep(navigateStep));
          window.scrollTo(0, 0);
        }
      });
      if (!navigateStep) {
        backToList();
      }
    };

  return (
    <>
      <div className="vehicle-referral-select-options">
        <h2>Select options</h2>
        <p>
          In accordance with FMR 102-34.50, optional equipment selections should
          be limited to what is mission essential. Not all selected options are
          guaranteed. Options selected may affect the final lease rate.
        </p>

        {isLoading ? (
          <Spinner size="large" />
        ) : (
          <>
            <Accordion
              items={[
                {
                  id: 'minimum-requirements',
                  key: 'minimum-requirements',
                  title: (
                    <div className="select-options-accordion-title">
                      <div>Minimum requirements</div>
                      <div>GSA Minimum requirements</div>
                    </div>
                  ),
                  content: minimumOptions.error ? (
                    <Alert type="error">
                      There was an issue loading the minimum requirements.
                    </Alert>
                  ) : Object.keys(minimumOptions.data).length === 0 ? (
                    <Alert type="warning">
                      There were no minimum requirements found for this standard
                      item.
                    </Alert>
                  ) : (
                    <div className="minimum-requirements">
                      {Object.keys(minimumOptions.data).map((key) => (
                        <MinimumRequirementGroup
                          key={key}
                          name={key}
                          options={minimumOptions.data[key]}
                        />
                      ))}
                    </div>
                  ),
                  expanded: true,
                },
                {
                  id: 'additional-options-req',
                  key: 'additional-options-req',
                  title: <>Add Options</>,
                  className: 'additional-options-wrapper',
                  content: additionalOptions.error ? (
                    <Alert type="error">
                      There was an issue loading the additional options.
                    </Alert>
                  ) : Object.keys(additionalOptions.data).length === 0 ? (
                    <Alert type="warning">
                      There were no additional options found for this standard
                      item.
                    </Alert>
                  ) : (
                    <div className="additional-options">
                      {Object.keys(additionalOptions.data).map((key) => (
                        <AdditionalOptionsGroup
                          key={key}
                          name={key}
                          options={additionalOptions.data[key]}
                        />
                      ))}
                    </div>
                  ),
                  expanded: true,
                },
              ]}
              id="select-options-accordion"
              className=""
              bordered={false}
            />
          </>
        )}
      </div>

      <AdditionalRequestActionButtons
        prevButton={{
          label: 'Previous',
          leftIcon: { name: 'arrow_back' },
          onClick: handleSubmit(true, ADDITIONAL_VEHICLE_STEPS.GARAGE),
        }}
        cancelButton={{
          label: 'Cancel request',
          disabled: false,
        }}
        saveButton={{
          onClick: handleSubmit(false, null),
        }}
        submitButton={{
          label: 'Next',
          leftIcon: null,
          rightIcon: { name: 'arrow_forward' },
          onClick: handleSubmit(true, ADDITIONAL_VEHICLE_STEPS.REVIEW_SUBMIT),
        }}
        nextFormId={'vehicle-garage-form'}
        hideButtons={['returnToSearch', 'returnRequest', 'fillExistVehicle']}
      />
    </>
  );
}
